import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
var SquareImage = function SquareImage() {
  return import('~/components/atoms/Product/SquareImage.vue');
};

export default {
  name: 'ZoomableImage',
  components: {
    SquareImage: SquareImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      delayClick: 400,
      tapFirst: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (process.client) {
      /* eslint-disable global-require */
      var Panzoom = require('@panzoom/panzoom');
      /* eslint-enable global-require */


      var panzoomElement = Panzoom(this.$refs.pinchReference, {
        minScale: 1,
        maxScale: 3,
        contain: 'outside',
        startScale: 1,
        zoom: 3
      });
      this.$refs.pinchReference.addEventListener('touchstart', function (event) {
        if (!_this.tapFirst) {
          _this.tapFirst = true;
          _this.tapTimeout = setTimeout(function () {
            _this.tapFirst = false;
          }, _this.delayClick);
        } else {
          if (_this.getScale() >= 3) {
            panzoomElement.reset();
          } else if (_this.getScale() >= 2) {
            panzoomElement.zoom(3, {
              animate: true
            });
          } else {
            panzoomElement.zoom(2, {
              animate: true
            });
          }

          _this.tapFirst = false;
          _this.tapTimeout = clearTimeout(_this.tapTimeout);
          event.preventDefault();
          event.stopPropagation();
        }

        if (_this.isZoomed() || _this.isPinched(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
      this.$refs.pinchReference.addEventListener('touchmove', function (event) {
        if (_this.isZoomed() || _this.isPinched(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
      this.$refs.pinchReference.addEventListener('touchend', function (event) {
        if (_this.isZoomed()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
      this.$refs.pinchReference.addEventListener('touchleave', function (event) {
        if (_this.isZoomed() || _this.isPinched(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
      this.$refs.pinchReference.addEventListener('touchcancel', function (event) {
        if (_this.isZoomed() || _this.isPinched(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  },
  methods: {
    isZoomed: function isZoomed() {
      return this.getScale() > 1;
    },
    isPinched: function isPinched(eventScope) {
      return eventScope.targetTouches.length === 2;
    },
    isTouched: function isTouched(eventScope) {
      return eventScope.targetTouches.length === 1;
    },
    regexScale: function regexScale(scale) {
      var regex = /(\w+)\(([^)]*)\)/g;
      return regex.exec(scale);
    },
    getScale: function getScale() {
      var style = this.$refs.pinchReference.style;

      var _this$regexScale = this.regexScale(style.transform),
          _this$regexScale2 = _slicedToArray(_this$regexScale, 3),
          scaleValue = _this$regexScale2[2];

      return parseFloat(scaleValue, 10);
    }
  }
};